import orderBy from "lodash/orderBy";

// Used for scrubber and capture page dropdown lists
export default orderBy(
  [
    "Dispose",
    "Donate",
    "Move",
    "Storage",
    "Recycle",
    "Resell",
    "Reuse",
    "Salvage",
    "Re-Install",
  ],
  v => v.toLowerCase()
);

